import React, { createContext, useContext } from 'react'

import merge from 'lodash.merge'

import { addEvent, sendEvent } from 'lib/AnalyticsGDM/analytics'

const ReactEventContext = createContext({})

/**
 *
 * @type {import('.').UseEventContextType}
 */
export const useEventContext = (fallbackEvent = {}) => {
  const contextValue = useContext(ReactEventContext)
  const mergedEvent = merge({}, fallbackEvent, contextValue)
  return {
    addEvent: (evt, options) => {
      return addEvent(merge({}, mergedEvent, evt), options)
    },
    sendEvent: evt => {
      return sendEvent(merge({}, mergedEvent, evt))
    },
    event: mergedEvent,
  }
}

/**
 *
 * @type {import('.').EventContextType}
 */
export const EventContext = ({ children, value, dangerouslyInheritContext }) => {
  const { event } = useEventContext()
  let mergedEvent = value
  if (dangerouslyInheritContext) {
    mergedEvent = merge({}, event, value)
  }
  return <ReactEventContext.Provider value={mergedEvent}>{children}</ReactEventContext.Provider>
}
